import React, { useEffect, useState } from 'react';
import NewsCard from './subcomponents/NewsCard';
import newsLeft from '../img/png/news_background_left.png';
import newsRight from '../img/png/news_background_right.png';
import axios from 'axios';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

function News() {
  const [news, setNews] = useState(null);
  useEffect(() => {
    const getNews = async () => {
      const res = await axios.post(
        // 'https://api.sqreemtech-dev.com/sqreemwebsite/getjsonfroms3',
        'https://api-3.sqreemtech.com/sqreemwebsite/getjsonfroms3',
        {
          _class: 'SqreemWebsite',
          _function: 'GetJsonFromS3',
          _account: 'sqreem',
          _username: 'qrm_jek',
          _data: {
            tableName: 'sqreemnews',
          },
        }
      );

      const data = res.data.data.sqreemnews;

      const linkedinNews = [
        data.filter((news) => news.id === 'linkedinai')[0],
        data.filter((news) => news.id === 'linkedinwinner')[0],
        data.filter((news) => news.id === 'linkedinwinner2')[0],
      ];

      setNews(Object.entries(linkedinNews));
    };
    getNews();
  }, []);
  //ant loading
  const antIcon = <LoadingOutlined spin />;

  return (
    <>
      <section
        id='news'
        className='news d-flex-col align-items-center justify-content-center gap-4'
      >
        <div className='news_text'>
          <div className='line'></div>
          <h2 className='text-title'>What’s new at SQREEM</h2>
        </div>
        {Array.isArray(news) ? (
          <div className='news_cards'>
            <div className='news_cards_container'>
              <div className='cards_wrapper'>
                <ul className='cards_items'>
                  {news.map((item, index) => {
                    item = item[1];
                    return (
                      <NewsCard
                        key={index}
                        newsThumbnail={item.newsThumbnail}
                        newsName={item.newsName}
                        newsContent={item.newsContent}
                        newsLabel='Post'
                        newsDate={item.newsDate}
                        newsUrl={item.newsUrl}
                      />
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        ) : (
          <div className='news_loading d-flex align-items-center justify-content-center'>
            <Spin tip='Loading news updates..' indicator={antIcon} />
          </div>
        )}

        <div className='news_background d-flex justify-content-between'>
          <div className='news_background_left d-flex align-items-center'>
            <img src={newsLeft} alt='background' />
          </div>
          <div className='news_background_right d-flex-col justify-content-end'>
            <img src={newsRight} alt='background' />
          </div>
        </div>
      </section>
    </>
  );
}

export default News;
